export enum ImageQuality {
	Low = 50,
	Medium = 65,
	High = 75,
	VeryHigh = 85,
}

export const ALLOWED_IMAGE_QUALITIES: number[] = [
	ImageQuality.Low,
	ImageQuality.Medium,
	ImageQuality.High,
	ImageQuality.VeryHigh,
];

// Optimized quality settings for LCP performance
export const DEFAULT_IMAGE_QUALITY_MAIN: ImageQuality = ImageQuality.Medium; // Reduced from High to Medium for faster loading
export const DEFAULT_IMAGE_QUALITY_BLUR: ImageQuality = ImageQuality.Low;
export const DEFAULT_IMAGE_QUALITY_PRIORITY: ImageQuality = ImageQuality.High; // Higher quality for priority/LCP images

export function isAllowedQuality(q: number | undefined): q is ImageQuality {
	return q !== undefined && ALLOWED_IMAGE_QUALITIES.includes(q);
}

export function normalizeQuality(q: number | undefined, fallback: ImageQuality = DEFAULT_IMAGE_QUALITY_MAIN): number {
	if (q === undefined) return fallback;
	return isAllowedQuality(q) ? q : fallback;
}
